import MatomoTracker from './MatomoTracker';

const stats = MatomoTracker({
  url: 'https://stats.flowdust.com',
  siteId: 3,
  enableLinkTracking: true,
});

export default stats;
